import { Link, NavLink, Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Calendar, Receipt, MessageSquare, LogOut, Palette, Frame, Users, Images, Boxes, Activity, Menu as MenuIcon } from "lucide-react";

const NAV = [
  { to: "/admin",                       label: "Overview",   icon: LayoutDashboard, end: true },
  { to: "/admin/analytics",             label: "Traffic",    icon: Activity },
  { to: "/admin/events",                label: "Events",     icon: Calendar },
  { to: "/admin/menu",                  label: "Menu",       icon: MenuIcon },
  { to: "/admin/artworks",              label: "Artworks",   icon: Frame },
  { to: "/admin/artists",               label: "Artists",    icon: Users },
  { to: "/admin/page-galleries",        label: "Photos",     icon: Images },
  { to: "/admin/resource-pools",        label: "Capacity",   icon: Boxes },
  { to: "/admin/bookings",              label: "Bookings",   icon: Receipt },
  { to: "/admin/gallery-applications",  label: "Gallery",    icon: Palette },
  { to: "/admin/contacts",              label: "Messages",   icon: MessageSquare },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();

  if (!ready) return <div className="p-20 text-muted2">Loading…</div>;
  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />;
  }

  return (
    <div className="min-h-screen bg-cream flex">
      <aside className="w-60 border-r border-soft p-6 flex flex-col bg-cream-2">
        <Link to="/" className="block" data-testid="admin-back-home">
          <img
            src="https://customer-assets-cm19k8pv.emergentagent.net/job_goa-art-space/artifacts/47po7jix_final%20logo%20no%20background%20.png"
            alt="Carpe Diem Goa"
            className="h-16 w-auto object-contain -ml-1"
          />
        </Link>
        <div className="overline mt-1">Admin</div>

        <nav className="mt-12 space-y-1 flex-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 text-sm transition ${
                  isActive ? "bg-charcoal text-cream" : "hover:bg-cream"
                }`
              }
              style={({ isActive }) => isActive ? { background: "#1C1C19", color: "#F9F8F6" } : {}}
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
            >
              <n.icon size={16} />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-soft pt-4 mt-4">
          <div className="text-xs text-muted2 mb-2">{user.email}</div>
          <button
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            className="flex items-center gap-2 text-sm text-muted2 hover:text-charcoal"
            data-testid="admin-logout"
          >
            <LogOut size={14}/> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 p-10 lg:p-14 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
